// Must stay first: the installed immersive Quest app requests its XR session
// before anything else loads (no-op elsewhere).
import './utils/questBoot';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initDesktopBridge } from './desktopBridge';

// No-op in browsers; wires native menu commands when running in GathrXR Studio.
initDesktopBridge();

// Self-heal after deploys: when a lazily-imported chunk 404s because the
// running page predates the current deployment (hashed filenames changed),
// reload once to pick up the new index.html instead of crashing.
window.addEventListener('vite:preloadError', (event) => {
  const key = 'gathrxr.chunkReloadAt';
  const last = Number(sessionStorage.getItem(key) || 0);
  if (Date.now() - last > 30000) { // guard against reload loops
    sessionStorage.setItem(key, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);
